import type { LucideIcon } from 'lucide-react'

/**
 * Envelope dos ícones lucide para obedecer o guia de marca:
 * "traço de 3 px, pontas arredondadas, em grade de 48 × 48. Use em preto ou
 *  branco, nunca com mais de uma cor."
 *
 * A razão 3/48 = 1/16 é o que mantém o peso do traço em qualquer tamanho —
 * usar strokeWidth fixo deixaria o ícone de 16px pesado e o de 48px fino.
 */
export type IconeProps = {
  de: LucideIcon
  tamanho?: number | undefined
  cor?: 'texto' | 'marca' | 'preto' | 'branco' | 'herdar' | undefined
  titulo?: string | undefined
  className?: string | undefined
}

const COR: Record<NonNullable<IconeProps['cor']>, string> = {
  texto: 'var(--du-texto)',
  marca: 'var(--du-marca-cor)',
  preto: 'var(--du-preto)',
  branco: 'var(--du-branco)',
  herdar: 'currentColor',
}

export function Icone({ de: Glifo, tamanho = 24, cor = 'herdar', titulo, className }: IconeProps) {
  return (
    <Glifo
      size={tamanho}
      strokeWidth={tamanho / 16}
      absoluteStrokeWidth
      color={COR[cor]}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden={titulo ? undefined : true}
      aria-label={titulo}
      role={titulo ? 'img' : undefined}
    />
  )
}
